import HoverCard from "./HoverCard";
import React from "react";
import gridImage1 from "../images/zta_emotional_trader.webp";
import gridImage2 from "../images/zta_equity_example.png";
import gridImage3 from "../images/zta_gridimage_3.webp";
import Slide from "react-reveal/Slide";
import SectionTitleEmotions from "./SectionTitleEmotions";

const EmotionHoverCardSection = () => {
  const cardsData = [
    {
      title: "Trade Without Emotions",
      description:
        "Our algorithms execute trades with perfect discipline, eliminating fear, greed, and other emotional biases that plague manual traders.",
      img: gridImage1,
    },
    {
      title: "Consistent Performance",
      description:
        "Experience steady returns with our battle-tested algorithms that maintain consistent performance powered by diversified strategies.",
      img: gridImage2,
    },
    {
      title: "Freedom to Focus",
      description:
        "Let our algorithms handle the trading while you focus on what matters most. No more staring at charts or missing opportunities.",
      img: gridImage3,
    },
  ];

  return (
    <div className="automation-emotions-section">
      <SectionTitleEmotions />
      <div className="emotion-cards-grid">
        {cardsData.map((card, index) => (
          <Slide bottom key={index}>
            <HoverCard
              title={card.title}
              description={card.description}
              imageSrc={card.img}
            />
          </Slide>
        ))}
      </div>
    </div>
  );
};

export default EmotionHoverCardSection;
